import "./SolutionCode.css"
import ReadOnlyCodeBlock from "./ReadOnlyCodeBlock";
import { useEffect, useRef, useState } from "react";
import FetchStartingCode from "../../../../ClientProblemRouter/fetchStartingCode";
import { getLanguageByID } from "../../../../Data/ProblemsMethod"; 
import { logRoles } from "@testing-library/dom";
import CodeBlock from "../../DescriptionAndSolution/PreviousAttempts/CodeBlock"
import FetchSolutionCode from "../../../../ClientProblemRouter/fetchSolutionCode";
import { getPossibleLanguagesForProblemAsInt } from "../../../../Data/ProblemsMethod";
import { getLanguageIDbyName } from "../../../../Data/ProblemsMethod";

export default function SolutionCode({problemID}){
    const [language_id, set_language_id] = useState(getLanguageIDbyName("C++")); // cpp by default 
    const [solution_code, set_solution_code] = useState("");
    const [show_solution, set_show_solution] = useState(false);
    const show_lang_ref = useRef(null);
    const [language_ref_selected, set_language_ref_selected] = useState(false);

    useEffect(() => {
        const getNewSolutionCode = async () => {
            set_solution_code(await FetchSolutionCode(problemID, language_id));
        }
        getNewSolutionCode();
    }, [language_id]);

    // Close dropdown on click outsie
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (show_lang_ref.current && !show_lang_ref.current.contains(event.target)) {
                set_language_ref_selected(false);
            }
        };
        window.addEventListener("click", handleClickOutside);

        return () => {
            window.removeEventListener("click", handleClickOutside);
        };

    }, []);


    // Get the possible languages for the solution 
    const [all_language_items, set_all_language_items] = useState([]);
    useEffect(() => {
        const possibleLangs = getPossibleLanguagesForProblemAsInt(problemID);

        const allLanguageItemsTemp = possibleLangs.map(langID => {
            return <div className="language-item" onMouseDown={() => set_language_id(langID)}> {getLanguageByID(langID)} </div>
        })
        set_all_language_items(allLanguageItemsTemp)
    }, [problemID]);

    return(
        <div className="solution-code-outer-container">
           
           
           <div className="options-above-solution-code">


                <div className="show-solution-language-button-container">
                    <button
                        onClick={() => set_language_ref_selected(!language_ref_selected)}
                        className="show-solution-language-button" 
                        ref={show_lang_ref} 
                    >
                        Language {!language_ref_selected ? <i className="arrow-solution up-solution"/> : <i className="arrow-solution down-solution"/>}
                    </button>

                    {language_ref_selected && (
                        <div className="language-dropdown-show-solution">
                            {all_language_items}
                        </div>
                    )}
                </div>
            
                <div className="show-solution-container">

                    <div className="show-solution-text">
                        Show Solution
                    </div>
                    <label className="solution-toggle">
                        <input 
                            className="show-solution-toggle-input-button"
                            type="checkbox"
                            checked={show_solution}
                            onChange={() => set_show_solution(!show_solution)}
                        />
                    </label>
                </div>
           </div>

          




            {show_solution && 
            <div className="solution-code-block-wrapper">
                <ReadOnlyCodeBlock code={solution_code} language={getLanguageByID(language_id)} />
            </div>}

        </div>
    );
}




